var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusAwaitingInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uvtk6boiha"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 397",
    transform: "translate(6362 1708)",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-542 -382)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 24",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(542 382)",
    style: {
      fill: "#e2bb17"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1",
    transform: "translate(-5820 -1326)",
    style: {
      clipPath: "url(#uvtk6boiha)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61568",
    d: "M12.308 3.077a9.231 9.231 0 1 0 9.231 9.231 9.233 9.233 0 0 0-9.231-9.231z",
    style: {
      stroke: "#e2bb17",
      strokeMiterlimit: 10,
      fill: "none",
      strokeWidth: "1.538px"
    },
    transform: "translate(6359.692 1705.692)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61569",
    d: "M12.308 6.154v6.923h4.615",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      strokeWidth: "1.538px"
    },
    transform: "translate(6359.692 1705.692)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusAwaitingInfoIcon);
export default __webpack_public_path__ + "static/media/Status-Awaiting-info-Icon.886263390b5e3472ed2748938627704b.svg";
export { ForwardRef as ReactComponent };